import { Injectable } from '@angular/core';
import { BaseDataService } from './base.data.service';
import { HttpClient } from '@angular/common/http';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import { IFuelPriceAdjusterSetting } from '../interfaces/fuel-price-adjuster-setting';
import { IFuelPriceAdjusterPrice } from '../interfaces/fuel-price-adjuster-price';

@Injectable({
  providedIn: 'root',
})
export class FuelPriceAdjusterService extends BaseDataService {
  public url = '/api/FuelPriceAdjuster';

  constructor(public http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  public getPrices(): Promise<IFuelPriceAdjusterPrice[]> {
    return this.http.get<IFuelPriceAdjusterPrice[]>(`${this.url}/prices`).toPromise();
  }

  public getSettings(): Promise<IFuelPriceAdjusterSetting[]> {
    return this.http.get<IFuelPriceAdjusterSetting[]>(`${this.url}/settings`).toPromise();
  }

  public getStatus(): Promise<boolean> {
    return this.http.get<boolean>(`${this.url}/status`).toPromise();
  }

  public updateFuelPriceAdjusterStatus() {
    return this.http.put<void>(`${this.url}/status`, {}).toPromise();
  }

  public updateFuelPrices(dto: IFuelPriceAdjusterPrice) {
    return this.http.put<void>(`${this.url}/prices`, dto).toPromise();
  }

  public getDisabledCustomerIds(): Promise<string> {
    return this.http.get(`${this.url}/disabledCustomers`, { responseType: 'text' }).toPromise();
  }

  public updateFuelPriceAdjusterDisabledCustomers(customerIds: string) {
    return this.http
      .put<void>(`${this.url}/disabledCustomers?customerIds=${customerIds}`, {})
      .toPromise();
  }
}
